<style scoped lang="less">
    .stepContainer-footer {
        .button {
            margin-top: 5px !important;
        }
        padding: 20px;
        display: flex;
        justify-content: space-between;
    }

    .invoiceData {
        .toggle {
            content: ' ';
            display: inline-block;

            border-top: 5px solid transparent;
            border-bottom: 5px solid transparent;
            border-left: 5px solid currentColor;

            vertical-align: middle;
            margin-right: .7rem;
            transform: translateY(-2px);

            transition: transform .2s ease-out;
        }
        .expanded .toggle {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }
        .expanded .toggle {
            transform: rotate(90deg) translateX(-3px);
        }
        .expandable {
            cursor: pointer;
        }
        .vertical-spacer {
            height: 50px;
        }
        table {
            display: table;
            flex-shrink: 0;
            width: 100%;
            & > tr:first-of-type {
                border-top: 0;
                background-color: #D0D0D0;
            }
            tr.header-columns td {
                border-bottom: 1px solid #D0D0D0;
            }
            & > tr.data-row:first-of-type td {
                border-top: 0px;
            }
            & > tr > td {
                border-top: 1px solid #D0D0D0;
                padding-left: 15px;
                padding-right: 15px;
            }
            & > tr > td:last-of-type {
                text-align: right;
            }
            & > tr > th {
                padding-left: 15px;
                padding-right: 15px;
            }
            & > tr > th:last-of-type {
                text-align: right;
            }
            & > tr.expandedtr > td {
                border-top: 0px;
            }
            & > tr.expandedtr > td:first-of-type {
                text-indent: 50px;
            }
            th.groupfooter {
                border-top: 2px solid #D0D0D0;
                background-color: #D0D0D0;
                font-size: 18px;
            }
            th.groupheader {
                font-size: 18px;
                text-align: center !important;
            }
            input[type='text'] {
                height: 20px;
            }
            .addMiscRow {
                background-color: #eeeeee;
            }
        }
    }
</style>
<template>
    <div class="column is-12">
        <div class="div-table">
            <div class="columns">
                <div class="column is-12 card-header has-text-centered button-tools">
                    Create Invoice
                </div>
            </div>
            <div class="columns">
                <div class="column is-12">
                    <div
                            v-if="!franchises.length || (step == 2 && !invoiceInfo)"
                            class="spinner-loader"
                    >
                        <sync-loader/>
                        <p>Loading ...</p>
                    </div>
                    <div
                            v-if="franchises.length && step == 1"
                            class="stepContainer-body"
                    >
                        <div class="columns">
                            <div class="column is-6">
                                <single-line-form-element label="Franchise:" padding-top="15px">
                                    <v-autocomplete
                                            v-model="selectedFranchise"
                                            :items="franchises"
                                            item-value="id"
                                            item-text="name"
                                            hide-details
                                            hide-selected solo>
                                    </v-autocomplete>
                                </single-line-form-element>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-5 fieldItemContainer">
                                <dialog-date-picker label="Start Date:" textLabel="Start Date"
                                                    v-model="startDate"></dialog-date-picker>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-5 fieldItemContainer">
                                <dialog-date-picker
                                        label="End Date:"
                                        textLabel="End Date"
                                        v-model="endDate"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                            v-if="invoiceInfo !== null && step == 2"
                            class="stepContainer-body"
                    >
                        <div class="invoiceData">
                            <table>
                                <tr>
                                    <th
                                            class="groupheader"
                                            colspan="4"
                                    >
                                        Venue Details
                                    </th>
                                </tr>
                                <tr class="header-columns">
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Total</th>
                                    <th>Actions</th>
                                </tr>
                                <template v-for="date in Object.keys(invoiceInfo.dates)">
                                    <template v-if="ignoreFields.indexOf(date) < 0">
                                        <tr
                                                :class="{'data-row': true, dateRow: true, expanded: getExpandedValueForDate(date), expandable:true}"
                                                @click="invoiceInfo.dates[date].expanded = !invoiceInfo.dates[date].expanded"
                                        >
                                            <td>
                                                <span class="toggle"/>
                                                <span>{{ date | convertDate }}</span>
                                            </td>
                                            <td>
                                                {{ invoiceInfo.dates[date].description }}
                                            </td>
                                            <td>
                                                $<input
                                                    type="text"
                                                    :value="calculateDateTotalInvoiceAmount(invoiceInfo.dates[date])"
                                                    disabled
                                            >
                                            </td>
                                            <td>
                                                <a
                                                        data-tooltip="Delete Line Entry"
                                                        class="btn-icon tooltip"
                                                        @click.stop="deleteInvoiceData(invoiceInfo.dates, date)"
                                                >
                                                    <i class="far fa-ban has-text-danger"/>
                                                </a>
                                            </td>
                                        </tr>
                                        <template
                                                v-for="venueid in Object.keys(invoiceInfo.dates[date])"
                                                v-if="getExpandedValueForDate(date)"
                                        >
                                            <template v-if="ignoreFields.indexOf(venueid) < 0">
                                                <template v-for="(session, index) in invoiceInfo.dates[date][venueid]">
                                                    <tr class="expandedtr">
                                                        <td>{{ session.name }} {{ session.session }}</td>
                                                        <td>
                                                            {{ session.description }}
                                                        </td>
                                                        <td>
                                                            $<input
                                                                style="background-color:#FFF"
                                                                type="text"
                                                                :value="getInvoiceAmount(session.invoiceAmount)"
                                                                disabled
                                                                @change="calcInvoiceAmount(invoiceInfo.dates[date][venueid][index], $event.target.value)"
                                                        >
                                                        </td>
                                                        <td>
                                                            <a
                                                                    data-tooltip="Delete Line Entry"
                                                                    class="btn-icon tooltip"
                                                                    @click.stop="deleteInvoiceData(invoiceInfo.dates[date][venueid], index)"
                                                            >
                                                                <i class="far fa-ban has-text-danger"/>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <tr>
                                    <th
                                            class="groupfooter"
                                            colspan="4"
                                    >
                                        Total: ${{ invoiceInfo.dates.invoiceAmount | currencyFormat }}
                                    </th>
                                </tr>
                            </table>
                            <div class="vertical-spacer"/>
                            <table>
                                <tr>
                                    <th
                                            class="groupheader"
                                            colspan="4"
                                    >
                                        Miscellaneous
                                    </th>
                                </tr>
                                <tr>
                                    <td
                                            colspan="4"
                                            class="addMiscRow"
                                    >
                                        <div class="columns">
                                            <div class="column is-4">
                                                <input
                                                        style="background-color:#FFF"
                                                        ref="miscdescadd"
                                                        type="text"
                                                        placeholder="Description"
                                                >
                                            </div>
                                            <div class="column is-4">
                                                <input
                                                        style="background-color:#FFF"
                                                        ref="miscamtadd"
                                                        type="text"
                                                        placeholder="Amount"
                                                >
                                            </div>
                                            <div class="column is-4">
                                                <a
                                                        class="button button-tools"
                                                        @click="addMiscellaneousLineItem()"
                                                >Add Misc. Line Item</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="header-columns">
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Total</th>
                                    <th>Actions</th>
                                </tr>
                                <template v-for="(lineEntry, index) in (invoiceInfo.miscellaneous)">
                                    <tr>
                                        <td>{{ lineEntry.date }}</td>
                                        <td>
                                            {{ lineEntry.description }}
                                        </td>
                                        <td>
                                            $<input
                                                type="text"
                                                :value="getInvoiceAmount(lineEntry.invoiceAmount)"
                                                @change="calcInvoiceAmount(lineEntry, $event.target.value)"
                                        >
                                        </td>
                                        <td>
                                            <a
                                                    data-tooltip="Delete Line Entry"
                                                    class="btn-icon tooltip"
                                                    @click.stop="deleteInvoiceData(invoiceInfo.miscellaneous, index)"
                                            >
                                                <i class="far fa-ban has-text-danger"/>
                                            </a>
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <th
                                            class="groupfooter"
                                            colspan="4"
                                    >
                                        Total: ${{ miscellaneousTotal | currencyFormat }}
                                    </th>
                                </tr>
                            </table>

                            <div class="vertical-spacer"/>
                            <table>
                                <tr>
                                    <th
                                            class="groupfooter"
                                            colspan="4"
                                    >
                                        Invoice Total: ${{ getInvoiceTotal() | currencyFormat }}
                                    </th>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div
                            v-if="stepData !== null && step == 3"
                            class="stepContainer-body"
                    >
                        <div class="invoiceData">
                            <v-alert :type="(stepData.error ? 'error' : 'success')">{{stepData.message}}</v-alert>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-12 is-flex stepContainer-footer">
                    <div><a v-if="getBackButtonTextForStep !== ''"
                            class="button button-tools"
                            @click="backward()"
                    >{{ getBackButtonTextForStep }}</a>
                    </div>
                    <div>
                    <a
                            v-if="getForwardButtonTextForStep !== ''"
                            class="button button-tools"
                            @click="forward()"
                    >{{ getForwardButtonTextForStep }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import vuetify from 'vuetify'
    import moment from 'moment'
    import axios from 'axios'
    import DatePicker from '../../helpers/Datepicker.vue'
    import ModalDialog from '../../helpers/Dialog.vue'
    import Vue from 'vue'
    import DialogDatePicker from '../../helpers/DialogDatePicker'
    import SingleLineFormElement from '../../helpers/SingleLineFormElement'

    export default {
        name: 'ToolsFranchiseCreateinvoice',
        filters: {
            convertDate(value) {
                return moment(value).format('MMM D YYYY')
            },
            currencyFormat(value) {
                return parseFloat(value).toFixed(2)
            }
        },
        components: {
            DialogDatePicker,
            moment,
            Vue,
            ModalDialog,
            DatePicker,
            SingleLineFormElement,
            vuetify
        },
        props: {
            token: {
                type: String,
            },
            user: {
                type: Object,
            },
            isNew: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                invoiceInfo: null,
                franchises: [],
                selectedFranchise: null,
                startDate: null,
                endDate: null,
                ignoreFields: ['invoiceAmount', 'expanded', 'description'],
                step: 1,
                miscellaneousTotal: 0.00,
                stepData: null
            }
        },
        computed: {
            getBackButtonTextForStep() {
                switch (this.step) {
                    case 1:
                        return 'Cancel'
                    case 3:
                        return ''
                    default:
                        return 'Go back'
                }
            },
            getForwardButtonTextForStep() {
                switch (this.step) {
                    case 1:
                        return 'Continue'
                    case 2:
                        return 'Create Invoice'
                    case 3:
                        return 'Create another'
                }
            }
        },
        watch: {},
        mounted: function () {
            this.getFranchises()
        },
        methods: {
            resetInvoiceData() {
              this.selectedFranchise = this.franchises[0]
              this.startDate = null
              this.endDate = null
              this.invoiceInfo = null
              this.step = 1
            },
            addMiscellaneousLineItem() {
                if (this.$refs.miscdescadd.value === '' || this.$refs.miscamtadd.value === '') {
                    this.$emit('mesasge', {
                        error: true,
                        message: 'Please fill out the description and amount fields before adding a line item'
                    })
                    return
                }
                this.invoiceInfo.miscellaneous.push({
                    date: moment().format('MMM DD YYYY'),
                    description: this.$refs.miscdescadd.value,
                    invoiceAmount: this.$refs.miscamtadd.value
                })
                this.$refs.miscdescadd.value = ''
                this.$refs.miscamtadd.value = ''
                this.getMiscellaneousTotal()
            },
            getInvoiceTotal() {
                let venuesTotal = this.getVenuesTotal()
                let miscTotal = this.getMiscellaneousTotal()
                return venuesTotal + miscTotal
            },
            getVenuesTotal() {
                return this.invoiceInfo.dates.invoiceAmount
            },
            getMiscellaneousTotal() {
                let invoiceAmount = 0
                this.invoiceInfo.miscellaneous.forEach((lineEntry) => {
                    invoiceAmount += parseFloat(lineEntry.invoiceAmount)
                })
                this.miscellaneousTotal = invoiceAmount.toFixed(2)
                return invoiceAmount
            },
            deleteInvoiceData(obj, key) {
                if (Array.isArray(obj)) {
                    obj.splice(key, 1)
                } else {
                    Vue.delete(obj, key)
                }
            },
            calculateDateTotalInvoiceAmount(venuesForDate) {
                let amount = 0.00
                switch (this.invoiceInfo.franchiseInfo.auto_invoice_type) {
                    case 'Per day.':
                        amount = parseFloat(venuesForDate.invoiceAmount)

                        // Now calculate additional fees from items below this input
                        Object.keys(venuesForDate).forEach((venueid) => {
                            if (this.ignoreFields.indexOf(venueid) < 0) {
                                venuesForDate[venueid].forEach((session) => {
                                    amount += parseFloat(session.invoiceAmount)
                                })
                            }
                        })
                        break
                    case 'Per session.':
                        Object.keys(venuesForDate).forEach((venueid) => {
                            if (this.ignoreFields.indexOf(venueid) < 0) {
                                venuesForDate[venueid].forEach((session) => {
                                    amount += parseFloat(session.invoiceAmount)
                                })
                            }
                        })
                        break
                    case 'Per Location. Per day.':
                        amount = venuesForDate.invoiceAmount
                        Object.keys(venuesForDate).forEach((venueid) => {
                            if (this.ignoreFields.indexOf(venueid) < 0) {
                                venuesForDate[venueid].forEach((session) => {
                                    amount += parseFloat(session.invoiceAmount)
                                })
                            }
                        })
                        break
                }
                venuesForDate.invoiceAmount = amount
                this.calculateTotalInvoiceAmount()
                return amount.toFixed(2)
            },
            calculateTotalInvoiceAmount() {
                let totalInvoiceAmount = 0
                Object.keys(this.invoiceInfo.dates).forEach((date) => {
                    if (this.ignoreFields.indexOf(date) < 0) {
                        totalInvoiceAmount += parseFloat(this.invoiceInfo.dates[date].invoiceAmount)
                    }
                })

                this.invoiceInfo.miscellaneous.forEach((lineEntry) => {
                    totalInvoiceAmount += parseFloat(lineEntry.invoiceAmount)
                })

                this.invoiceInfo.invoiceAmount = totalInvoiceAmount
                return totalInvoiceAmount
            },
            getInvoiceAmount(value) {
                return typeof value !== 'undefined' ? parseFloat(value).toFixed(2) : (0).toFixed(2)
            },
            calcInvoiceAmount(obj, value) {
                obj.invoiceAmount = this.getInvoiceAmount(value)
            },
            getExpandedValueForDate(date) {
                return this.invoiceInfo.dates[date].expanded || false
            },
            getFranchises() {
                let url = `admin/tournaments/getfranchises`
                let data = {
                    token: this.token
                }
                this.$axios({
                    method: 'POST',
                    url,
                    headers: {
                        Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data
                })
                    .then((res) => {
                        this.franchises = res.data
                        this.selectedFranchise = res.data[0]
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            backward() {
                switch (this.step) {
                    case 1:
                        this.$router.push('/admin/franchises/invoices')
                        break
                    default:
                        this.step--
                }
            },
            forward() {
                switch (this.step) {
                    case 1:
                        this.step = 2
                        this.getInvoiceData()
                        break
                    case 2:
                        this.createInvoice().then((result) => {
                            this.stepData = result.data
                            this.step = 3
                        })
                        break
                    case 3:
                        this.resetInvoiceData()
                        break
                }
            },
            getInvoiceData() {
                let url = `admin/franchise/getinvoice`
                let data = {
                    token: this.token,
                    startDate: moment(this.startDate).format('YYYY-MM-DD'),
                    endDate: moment(this.endDate).format('YYYY-MM-DD'),
                    franchise: this.selectedFranchise.id,
                }
                this.$axios({
                    method: 'POST',
                    url,
                    headers: {
                        Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data
                })
                    .then((res) => {
                        this.invoiceInfo = res.data
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            createInvoice() {
                return new Promise((resolve, reject) => {
                    let url = `admin/franchise/createinvoice`
                    let data = {
                        token: this.token,
                        invoiceInfo: this.invoiceInfo,
                        franchise: this.selectedFranchise.id,
                    }
                    this.$axios({
                        method: 'POST',
                        url,
                        headers: {
                            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        data
                    })
                        .then((res) => {
                            resolve(res)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            }
        }
    }
</script>
